import MeetupSocialMap from "./maps/MeetupSocialMap";

/** Landing-page meetup map — Phase 0+1 geographic pins (WGS84). */
export default function MeetupMap(props) {
  return (
    <MeetupSocialMap
      variant="landing"
      mapHeight={360}
      showIslandPicker
      showParishFilter
      showStats
      showFeaturedStrip
      {...props}
    />
  );
}
